import { IIconActionButton } from 'app/shared/interfaces/IIconActionButton.interface';
import { ActionableItemState } from 'app/shared/models/actionable-item-state';
import { CaseClaimListItemModel } from './case-claim-list-item.model';

export class CaseClaimListItemViewModel extends ActionableItemState {
  editButton: IIconActionButton;
  deleteItemButton: IIconActionButton;

  constructor(dataModel: CaseClaimListItemModel, inScreenPop: boolean, allowEdit: boolean) {
    super();

    this.dataModel = dataModel;
  }
}
